import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'timeAgo',
  standalone: true
})
export class TimeAgoPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value?: string | Date): string {
    if (!value) return '';

    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return '';

    const now = new Date();

    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (diffInSeconds < 60) {
      return this.translate.instant('TIME.JUST-NOW');
    } else if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return this.translate.instant('TIME.MINUTES-AGO', { count: minutes });
    } else if (diffInSeconds < 86400) {
      const hours = Math.floor(diffInSeconds / 3600);
      return this.translate.instant('TIME.HOURS-AGO', { count: hours });
    } else if (diffInSeconds < 172800) {
      return this.translate.instant('TIME.YESTERDAY');
    } else {
      const days = Math.floor(diffInSeconds / 86400);
      return this.translate.instant('TIME.DAYS-AGO', { count: days });
    }
  }
}
